import { newToolFilterOAuthMcp } from "../oauth.ts";

export const thoughtspotMcpResolver = newToolFilterOAuthMcp({
  iconUrl: "https://www.thoughtspot.com/images/TS-FAV-180x180_Dark.png",
  url: "https://agent.thoughtspot.app/mcp",
  label: "ThoughtSpot",
});
